@if (!title) {
  <h1 class="dialog-title text-center">Are you sure you want to {{ action }} this {{ type }}?</h1>
}
@if (title) {
  <h1 class="dialog-title text-center">{{ title }}</h1>
}
@if (description) {
  <h3>{{ description }}</h3>
}

<div class="dialog-content">
  <div class="row">
    <div class="col-md-12">
      <h3 class="mb-5">
        Confirm by typing:
        <b>{{ confirmText }}</b>
      </h3>
      <form #confirmForm="ngForm">
        <div class="form-group">
          <label class="form-label capitalize">Type {{ confirmText }}</label>
          <input
            class="form-input"
            name="input_confirm_text"
            [(ngModel)]="inputConfirmText"
            required
            (blur)="confirmInput()"
            (keyup)="resetWrongInput()"
          />
        </div>
        @if (wrong_confirm_text) {
          <span class="text-red-500">That is not correct</span>
        }
      </form>

      <div class="dialog-actions mt-5 flex justify-end gap-5">
        <a (click)="onCloseDialog()" class="cancel-link">Cancel</a>
        <button
          type="button"
          class="btn-secondary"
          (click)="confirmAction()"
          [disabled]="!confirmForm.valid || wrong_confirm_text"
        >
          <span class="capitalize">{{ action }}</span>
        </button>
      </div>
    </div>
  </div>
</div>
